module.exports = __webpack_public_path__ + "static/img/business-cert.5bd4402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business-cert.jpg
// module id = ppvd
// module chunks = 1